// extracted by mini-css-extract-plugin
module.exports = {"video-section":"J_dj d-flex","video-section--header":"J_dk","video-section__frame":"J_dl ml-3"};